<script lang="ts">
    import Btn from "../../components/Btn.svelte";
    import Container from "../../components/Container.svelte";
    import Divider from "../../components/Divider.svelte";
    import DividerWave from "../../components/DividerWave.svelte";
    import Dropdown from "../../components/Dropdown.svelte";
    import Gap from "../../components/Gap.svelte";
    import Headline from "../../components/Headline.svelte";
    import Hero from "../../components/Hero.svelte";
    import Image from "../../components/Image.svelte";
    import LightTheme from "../../components/LightTheme.svelte";
    import PagePreviews from "../../components/PagePreviews.svelte";
    import PageTransition from "../../components/PageTransition.svelte";
    import Row from "../../components/Row.svelte";
    import Subline from "../../components/Subline.svelte";
    import { t } from "../../helpers/translation";
</script>

<!-- <LightTheme /> -->

<Hero
    headline={$t("page.itservice.hero.headline")}
    small
    vid="https://liveicom.azureedge.net/sinus/vid/sinus_it.mp4"
/>

<Container>
    <Headline>
        {@html $t("page.itservice.headline")}
    </Headline>
    <Subline>
        {@html $t("page.itservice.subline")}
    </Subline>
    <p>
        {@html $t("page.itservice.p.1")}
    </p>
    <p>
        {@html $t("page.itservice.p.2")}
    </p>
    <p>
        {@html $t("page.itservice.p.3")}
    </p>
    <p>
        {@html $t("page.itservice.p.4")}
    </p>

    <Btn href="kontakt" arrow>
        {@html $t("page.itservice.btn.contact")}
    </Btn>

    <Gap height="4rem" />
</Container>

<Container big>
    <PagePreviews leitstellen wachen_elw sprach_datenfunk />
</Container>

<!-- <DividerWave /> -->
